import type { Entity } from '@backstage/catalog-model';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

import { rootRouteRef } from './routes';

/**
 * Adds a "Leave Tracker" tab to Group entity pages. The tab is rendered for any
 * Group, but the content itself enforces that only members of that group can
 * see the tracker (see EntityLeaveTrackerContent).
 */
export const leaveTrackerEntityContent = EntityContentBlueprint.make({
  name: 'leave-tracker',
  params: {
    path: '/leave-tracker',
    title: 'Leave Tracker',
    filter: (entity: Entity) => entity.kind.toLowerCase() === 'group',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/EntityLeaveTrackerContent').then(m => (
        <m.EntityLeaveTrackerContent />
      )),
  },
});

export const teamLeaveTrackerPlugin = createFrontendPlugin({
  pluginId: 'team-leave-tracker',
  extensions: [leaveTrackerEntityContent],
  routes: {
    root: rootRouteRef,
  },
});

export default teamLeaveTrackerPlugin;
